import React, { useContext } from 'react';
import clsx from 'clsx';
import { FocusHandler, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import Typography from '@smart-tv/components/typography/typography';
import { TvContext } from '@smart-tv/contexts';
import { APP_VERSION } from '@smart-tv/utils/api-constants';
import styles from '../developer.module.scss';

const PLAYER_VERSION = process.env.PLAYER_VERSION || '';

interface Props {
  onFocus?: FocusHandler;
}

export const DEVELOPER_BUILD_INFO_FOCUS_KEY = 'DEVELOPER_BUILD_INFO_FOCUS_KEY';

const DeveloperBuildInfo: React.FC<Props> = ({ onFocus }) => {
  const { appVersion, model, platform, platformVersion, connectionType, deviceUuid } =
    useContext(TvContext);
  const buildNumber = process.env.BUILD_NUMBER ?? '';
  const gitBranch = process.env.GIT_BRANCH ?? '';

  const { ref, focused } = useFocusable({ onFocus, focusKey: DEVELOPER_BUILD_INFO_FOCUS_KEY });

  const items: [string, string][] = [
    ['Environment', process.env.NODE_ENV ?? ''],
    ...(gitBranch ? [['Branch', gitBranch] as [string, string]] : []),
    ['App version', appVersion ?? ''],
    ...(buildNumber ? [['Build number', buildNumber] as [string, string]] : []),
    ['APP version', APP_VERSION],
    ['Player version', PLAYER_VERSION],
    ...(platform || platformVersion
      ? [['OS', [platform, platformVersion].filter(Boolean).join(' ')] as [string, string]]
      : []),
    ...(model ? [['Hardware model', model] as [string, string]] : []),
    ...(connectionType ? [['Connection', connectionType] as [string, string]] : []),
    ...(deviceUuid ? [['Device UUID', deviceUuid] as [string, string]] : [])
  ];

  return (
    <div
      ref={ref}
      className={clsx(styles['section__build-info'], focused && styles['section--focused'])}
    >
      {items.map(([label, value]) => (
        <div key={label} className={styles['section__build-item']}>
          <Typography variant="caption" className={styles['section__build-item-text']}>
            {label}
          </Typography>
          <Typography variant="caption" className={styles['section__build-item-text']}>
            {value}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default DeveloperBuildInfo;
